export enum DateRange {
  AllTime = 'allTime',
  LastYear = 'lastYear',
  LastMonth = 'lastMonth',
  LastWeek = 'lastWeek',
  CurrentMonth = 'currentMonth',
}
